import cn from 'clsx'
import {Avatar, AvatarProps} from 'antd'

import './UserAvatar.scss'
import userSvg from 'assets/images/user.svg'

export default function UserAvatar({className, src, ...props}: AvatarProps) {
  return (
    <Avatar
      {...props}
      className={cn(className, 'UserAvatar')}
      src={src || userSvg}
    />
  )
}
